import type { Project } from './api';

const dateOnly = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

export const formatDate = (iso: string) => dateOnly.format(new Date(iso));

const relative = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

/** "2 hours ago", "yesterday"; older than a week falls back to the date. */
export function timeAgo(iso: string, now = Date.now()): string {
  const seconds = Math.round((new Date(iso).getTime() - now) / 1000);
  const abs = Math.abs(seconds);
  if (abs < 60) return 'just now';
  if (abs < 3600) return relative.format(Math.round(seconds / 60), 'minute');
  if (abs < 86_400) return relative.format(Math.round(seconds / 3600), 'hour');
  if (abs < 7 * 86_400) return relative.format(Math.round(seconds / 86_400), 'day');
  return formatDate(iso);
}

export function initials(name: string): string {
  const letters = name
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0] ?? '')
    .join('');
  return (letters || '?').slice(0, 2).toUpperCase();
}

export const STATUS_NAMES: Record<Project['status'], string> = {
  in_development: 'In development',
  in_review: 'In review',
  live: 'Live',
  suspended: 'Suspended',
};

/** Two tile colours, alternated so neighbouring projects are easy to tell apart. */
export function tileClass(index: number): string {
  return index % 2 === 0 ? 'bg-brand' : 'bg-avatar';
}

/** `12.4 MB`, `820 KB`. */
export function formatBytes(bytes: number): string {
  if (bytes >= 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
}
